import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";

interface IProps {
  isOpen: boolean;
  handleClose: (
    event: {},
    reason: "backdropClick" | "escapeKeyDown"
  ) => Promise<void>;
  title?: string;
  hideCloseButton?: boolean;
  fullScreen?: boolean;
  height?: string;
  fullWidth?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
  keepMounted?: boolean;
  children: JSX.Element;
}

function BaseDialog(props: IProps) {
  return (
    <Dialog
      open={props.isOpen}
      onClose={props.handleClose}
      fullWidth={props.fullWidth ?? false}
      maxWidth={props.maxWidth ?? false}
      fullScreen={props.fullScreen ?? false}
      keepMounted={props.keepMounted ?? false}
      PaperProps={{
        sx: {
          height: props.height,
        },
      }}
    >
      <DialogContent>
        {props.title && (
          <Typography variant="h4" children={props.title} sx={{ pb: 2 }} />
        )}
        {props.children}
      </DialogContent>
      {(!props.hideCloseButton ?? true) && (
        <DialogActions>
          <Button onClick={() => props.handleClose({}, "escapeKeyDown")}>
            Close
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}

export default BaseDialog;
